/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCodepen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.591 1.371a.75.75 0 01.818 0l10 6.5a.75.75 0 01.341.629v7a.75.75 0 01-.341.629l-10 6.5a.75.75 0 01-.818 0l-10-6.5a.75.75 0 01-.341-.629v-7a.75.75 0 01.341-.629l10-6.5zM2.75 9.941L5.692 12 2.75 14.06V9.94zm.59 5.536l7.91 5.141v-4.727L7 12.915l-3.66 2.562zM8.309 12L12 14.585 15.692 12 12 9.415 8.308 12zm4.442-3.89L17 11.085l3.66-2.562-7.91-5.141V8.11zm-1.5-4.728V8.11L7 11.085 3.34 8.523l7.91-5.141zm10 6.558L18.308 12l2.942 2.06V9.94zm-.59 5.537L17 12.915l-4.25 2.976v4.727l7.91-5.141z'
      />
    </svg>
  );
}

export default SvgCodepen;
